<template>
	<div>
		<canvas ref="chart" :style="{ 'height': height + 'px' }"></canvas>
	</div>
</template>

<script>
import { Chart, registerables } from 'chart.js';
import DataLabelsPlugin from 'chartjs-plugin-datalabels'; // 新增插件引入

// 注册插件和核心功能
Chart.register(...registerables, DataLabelsPlugin); // 新增插件注册
//Chart.register(...registerables);

export default ({
	props: [
		'data',
		'height',
	],
	data() {
		return {
			chart: null,
			ctx: null
		};
	},
	watch: {
		data: {
			handler(newData) {
				this.$nextTick(() => {
					this.chart.data = newData
					this.chart.update()
				})
			},
			immediate: false
		}
	},
	mounted() {
		this.ctx = this.$refs.chart.getContext("2d");
		this.chart = new Chart(this.ctx, {
			type: "line",
			data: {
				labels: ["前天", "昨天", "今天"],
				datasets: [{
					label: "行程总数量",
					tension: 0.4,
					borderWidth: 0,
					pointRadius: 0,
					borderColor: "#1890FF",
					borderWidth: 3,
					data: [0, 0, 0],
					maxBarThickness: 6,
				},
				{
					label: "有效成交",
					tension: 0.4,
					borderWidth: 0,
					pointRadius: 0,
					borderColor: "#B37FEB",
					borderWidth: 3,
					data: [0, 0, 0],
					maxBarThickness: 6
				}],
			},
			options: {
				layout: {
					padding: {
						top: 30,
						right: 15,
						left: 10,
						bottom: 5,
					},
				},
				responsive: true,
				maintainAspectRatio: false,
				interaction: {
					mode: "index",
					intersect: false
				},
				plugins: {
					legend: {
						display: false,
					},
					datalabels: {
						color: '#666',
						anchor: 'end', // 标签位置
						font: {
							size: 16,
						},
						align: 'top',  // 对齐方式
						formatter: (value) => value // 空值不显示
					},
					tooltips: {
						enabled: true,
						mode: "index",
						intersect: false,
						backgroundColor: "rgba(0, 0, 0, 0.8)", // 背景颜色
						titleColor: "#fff", // 标题颜色
						bodyColor: "#fff", // 文本颜色
						borderColor: "#1890FF", // 边框颜色
						borderWidth: 2,
						padding: 10,
						// displayColors: false, // 不显示颜色块
						// callbacks: {
						// 	label: function (tooltipItem) {
						// 		console.log(tooltipItem)
						// 		return `销售额: ${tooltipItem.raw}`;
						// 	}
						// }
					},
				},
				scales: {
					y: {
						grid: {
							display: true,
							color: "rgba(0, 0, 0, .2)",
							zeroLineColor: "#000000",
							borderDash: [6],
							borderDashOffset: [6],
						},
						ticks: {
							suggestedMin: 0,
							suggestedMax: 1000,
							display: true,
							color: "#8C8C8C",
							font: {
								size: 14,
								lineHeight: 1.8,
								weight: '600',
								family: "Open Sans",
							},
						},
					},
					x: {
						grid: {
							display: false,
						},
						ticks: {
							display: true,
							color: "#8C8C8C",
							font: {
								size: 14,
								lineHeight: 1.5,
								weight: '600',
								family: "Open Sans",
							},
						},
					},
				},
			}
		})
	},
	// Right before the component is destroyed,
	// also destroy the chart.
	beforeDestroy: function () {
		this.chart.destroy();
	},
})

</script>

<style lang="scss" scoped></style>